define('gumbo-js-client-lib/forms/liveData/BoxTeamForm',{
	teamID: null,
	team: null,
	info: null,
	note: null,
	battingTotals: {
		atBats: null,
		avg: null,
		baseOnBalls: null,
		doubles: null,
		assists: null,
		hits: null,
		homeruns: null,
		leftOnBase: null,
		putOuts: null,
		runs: null,
		rbi: null,
		strikeOuts: null,
		triples: null
	},
	pitchingTotatls: {
		baseOnBalls: null,
		battersfFaced: null,
		errors: null,
		era: null,
		hits: null,
		homeruns: null,
		outs: null,
		runs: null,
		strikeOuts: null
	}
});
